import React from 'react';
import 'chartjs-plugin-datalabels';
import { Bar } from 'react-chartjs-2';
import { Box } from '@mui/material';
import { TypographySettings } from '../../../components/config';

const textColor = '#5b6b73';

const options = {
  responsive: true,
  maintainAspectRatio: false,
  // The numbers stand over the bars, so the chart has no tooltip or hover.
  events: [],
  legend: { display: false },
  layout: { padding: { top: 20 } },
  scales: {
    xAxes: [
      {
        gridLines: { display: false, drawBorder: false },
        ticks: { autoSkip: false, maxRotation: 0, fontSize: 12, fontColor: textColor, fontFamily: TypographySettings.DefaultFontFamily },
        barPercentage: 0.9,
        categoryPercentage: 0.8,
        maxBarThickness: 16,
      },
    ],
    yAxes: [{ display: false, ticks: { beginAtZero: true } }],
  },
  plugins: {
    datalabels: {
      anchor: 'end',
      align: 'end',
      offset: 1,
      color: '#16323d',
      font: { size: 11, weight: 600, family: TypographySettings.DefaultFontFamily },
    },
  },
};

export interface InterventionArrivalsSeries {
  label: string;
  counts: number[];
  barColors: string[];
}

export interface InterventionArrivalsChartProps {
  labels: string[][];
  series: InterventionArrivalsSeries[];
}

export function InterventionArrivalsChart({ labels, series }: InterventionArrivalsChartProps) {
  return (
    <Box sx={{ position: 'relative', flex: 1, minHeight: 240 }} aria-hidden>
      <Bar data={{ labels, datasets: series.map(serie => ({ label: serie.label, data: serie.counts, backgroundColor: serie.barColors })) }} options={options} />
    </Box>
  );
}
